import type { ButtonHTMLAttributes, ReactNode } from "react";

type ButtonVariant = "primary" | "secondary" | "ghost" | "danger" | "success";
type ButtonSize = "sm" | "md" | "lg";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  icon?: ReactNode;
  trailingIcon?: ReactNode;
}

export function Button({
  variant = "secondary",
  size = "md",
  icon,
  trailingIcon,
  className = "",
  children,
  type = "button",
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={`ds-button ds-button-${variant} ds-button-${size} ${className}`.trim()}
      {...props}
    >
      {icon && <span className="ds-button-icon">{icon}</span>}
      <span className="ds-button-label">{children}</span>
      {trailingIcon && <span className="ds-button-icon">{trailingIcon}</span>}
    </button>
  );
}

